/**
 * Service Worker Registration — LPA Wealth Portal
 *
 * Importar em main.jsx:
 *   import { registerSW } from "./registerSW.js";
 *   registerSW();
 */

export function registerSW() {
  if ("serviceWorker" in navigator && import.meta.env.PROD) {
    window.addEventListener("load", async () => {
      try {
        const reg = await navigator.serviceWorker.register("/sw.js", {
          scope: "/",
        });
        console.warn("[SW] Registered:", reg.scope); // eslint: warn/error only

        // Auto-update check a cada 60min (guardado para eventual cleanup)
        setInterval(() => reg.update(), 60 * 60 * 1000);

        // Notifica quando nova versão disponível
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "activated" && navigator.serviceWorker.controller) {
              console.warn("[SW] Nova versão disponível — recarregue a página");
              // Opcional: mostrar toast para o usuário
              if (window.__showUpdateToast) {
                window.__showUpdateToast();
              }
            }
          });
        });
      } catch (err) {
        console.warn("[SW] Registration failed:", err);
      }
    });
  }
}

export function unregisterSW() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((reg) => reg.unregister());
  }
}
